import styled from "styled-components";
import {MenuItemKey} from "../../../../../services/configurations/config-data-sections/generated-config-const";

export interface IAppHeaderCrossBrandItemProps {
  menuItemKey: MenuItemKey
}

export const AppHeaderCrossBrandItemDefaultBox = styled.div<IAppHeaderCrossBrandItemProps>`

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0 0.5rem;
  padding: 0;
  ${({theme}) => theme.font.presets.black};
  font-size: 0.9rem;
  line-height: 1;
  text-transform: uppercase;
  cursor: pointer;
  gap: 1rem;

  filter: grayscale(1);
  transition: filter 0.2s linear;
  &:hover {
    filter: none;
  }
  
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        
      svg {
        width: 18px;
      }
    }
`;
